import React from 'react';
import { ClientSideWizardConfiguration } from '../../../content-composer/src/contexts/ClientSideWizard/types';
import { MandateExecuteStep, RejectReasonStep, MandateInitiateStep } from './steps';

const useApproveRejectFlowConfig = (
  authAction: string | null,
  onToggleDrawer?: () => void,
  isBulk?: boolean,
  resetFlow?: () => void,
): ClientSideWizardConfiguration => {
  if (authAction === 'approve') {
    return {
      currentStep: 'mandateInitiate',
      data: {
        mandateInitiate: {
          stepId: 'mandateInitiate',
          isFirstStep: true,
          hasStepIndicator: false,
          cancelHidden: false,
          Component: () => (
            <MandateInitiateStep
              authAction={authAction}
              onToggleDrawer={onToggleDrawer}
              isBulk={isBulk}
              resetFlow={resetFlow}
            />
          ),
          parameters: {},
        },
        mandateExecute: {
          stepId: 'mandateExecute',
          isFirstStep: false,
          cancelHidden: false,
          hasStepIndicator: false,
          Component: () => <MandateExecuteStep authAction={authAction} isBulk={isBulk} />,
          parameters: {},
        },
      },
    };
  } else {
    return {
      currentStep: 'rejectReasonStep',
      data: {
        rejectReasonStep: {
          stepId: 'rejectReasonStep',
          isFirstStep: true,
          cancelHidden: false,
          hasStepIndicator: false,
          Component: RejectReasonStep,
          parameters: {},
        },
        mandateInitiate: {
          stepId: 'mandateInitiate',
          isFirstStep: false,
          hasStepIndicator: false,
          cancelHidden: false,
          Component: () => (
            <MandateInitiateStep
              authAction={authAction}
              hasRejectionReason={true}
              isBulk={isBulk}
              resetFlow={resetFlow}
            />
          ),
          parameters: {},
        },
        mandateExecute: {
          stepId: 'mandateExecute',
          isFirstStep: false,
          cancelHidden: false,
          hasStepIndicator: false,
          Component: () => <MandateExecuteStep authAction={authAction} isBulk={isBulk} />,
          parameters: {},
        },
      },
    };
  }
};

export { useApproveRejectFlowConfig };
